export default ({ $sentry, error }, inject) => {
    inject('handleError', (e) => {
        $sentry.captureException(e);

        error({
            message: e.message,
            statusCode: e.status,
        });
    });
};
